import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=86b87c8a&"
import script from "./Presets.vue?vue&type=script&lang=js&"
export * from "./Presets.vue?vue&type=script&lang=js&"
import style0 from "./Presets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports